export default {
      id: "favorite-full-usage",
      viewBox: "0 0 44 44",
      url: __webpack_public_path__ + "img/icons.e72ac2e3.svg#favorite-full",
      toString: function () {
        return this.url;
      }
    }